module.exports = __webpack_public_path__ + "img/Keyboard.745dc0b9.png";